import { AnyObject, Collection, CollectionItem } from '@hb/shared'
import { useEffect, useMemo, useState } from 'react'
import { subscribeToCollectionItem } from '../../../collections/utils/read'
import { useFetchData } from '../../../contexts/db/FetchDataContext'
import { useAuth } from '../../../store/auth'

interface UseCollectionItem<Data extends AnyObject> {
  item: CollectionItem<Data> | null
  loading: boolean
  error: string | null
}

export function useCollectionItem<Data extends AnyObject = AnyObject>(
  collection: Collection<Data> | null,
  itemId?: string | null,
): UseCollectionItem<Data> {
  const fetchData = useFetchData()
  const { accessLevel } = useAuth()
  // const collectionState = useCollection(collection)
  // const { loading, items = [] } = collectionState ?? {}

  // const item = useMemo(
  //   () => (items && itemId ? (items as CollectionItem<Data>[]).find((i) => i.id === itemId) : undefined),
  //   [items, itemId],
  // )
  const [loading, setLoading] = useState(!!(collection && itemId))
  const [error, setError] = useState<string | null>(null)
  const [item, setItem] = useState<CollectionItem<Data> | null>(null)

  useEffect(() => {
    if (!collection || !itemId || !accessLevel || !collection.access.includes(accessLevel)) {
      setLoading(false)
      setError(null)
      setItem(null)
      return () => {}
    }
    return subscribeToCollectionItem(fetchData, collection, accessLevel, itemId, {
      onData: data => {
        setItem(data)
      },
      onError: newError => {
        setError(newError)
      },
      onLoading: newLoading => {
        setLoading(newLoading)
      },
    })
  }, [collection, accessLevel, itemId, fetchData])

  return useMemo(() => ({ item, loading, error }), [item, loading, error])
}
